// Named, dated blocks stay independent of working periods, so moving one does
// not leave a second gap behind in the service schedule.
export function withNativeBlocks(info, blocks, iso, toMinutes) {
    const native = (blocks || []).filter(b =>
        String(b.startDate).slice(0, 10) === iso &&
        String(b.endDate).slice(0, 10) === iso
    ).map(b => ({
        start: toMinutes(String(b.startDate).slice(11, 16)),
        end: toMinutes(String(b.endDate).slice(11, 16)),
        kind: "native",
        nativeBlockId: b.id,
        title: b.name || "Blocked time",
    })).filter(b => b.end > b.start);
    let periods = [...(info.periods || [])];
    for (const block of native) {
        periods = periods.flatMap(p => [
            {...p, end: Math.min(p.end, block.start)},
            {...p, start: Math.max(p.start, block.end)},
        ].filter(p => p.end > p.start));
    }
    return {...info, periods, breaks: [...(info.breaks || []), ...native].sort((a, b) => a.start - b.start)};
}
